import { useState } from "react";
import styled from "styled-components";
import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Button } from "../Button";
import searchImg from "../../../assets/img/search.svg";
import Input from "./Input";
import Checkbox from "../Checkbox";

const SearchInputContainer = styled("div")(({ theme, width, isFocused }) => ({
  display: "flex",
  flexDirection: "row",
  marginInlineStart: 5,
  width,
  border: `1px solid ${isFocused ? theme.color.red : "#E1E1E1"}`,
  borderRadius: 6,
  backgroundColor: "#ffffff",
  alignItems: "center",
  transition: "border-color 120ms ease, box-shadow 120ms ease",
  boxShadow: isFocused ? `0 0 0 3px rgba(190, 30, 44, 0.12)` : "none",

  "&:hover": {
    borderColor: isFocused ? theme.color.red : "#B0B0B0",
  },
}));

const SearchInput = ({
  placeholder,
  width,
  onClick,
  onChange,
  value,
  isRtl,
  onKeyDown,
  setSearchByPart,
  isSearchByPart,
}) => {
  const { t } = useTranslation("common");
  const [isFocused, setIsFocused] = useState(false);
  return (
    <SearchInputContainer width={width} isFocused={isFocused}>
      <Input
        placeholder={t(placeholder)}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onKeyDown={onKeyDown}
        value={value ?? ""}
        transparentBorder={true}
        style={{
          margin: 0,
          height: "100%",
          fontSize: 16,
        }}
        isRtl={isRtl}
      />

      <Checkbox
        style={{
          margin: "0 0.5em",
          justifyContent: "end",
          display: "flex",
          maxWidth: 120,
        }}
        label={t("search_by_part")}
        checked={!!isSearchByPart}
        onChange={() => setSearchByPart(!isSearchByPart)}
        width={22}
        height={22}
      ></Checkbox>

      <Button
        style={{
          width: "41px",
          height: "41px",
          alignSelf: "center",
          margin: "8px",
          padding: "0",
          lineHeight: "12px",
        }}
        onClick={onClick}
      >
        <img src={searchImg} alt="search" />
      </Button>
    </SearchInputContainer>
  );
};

export default inject()(observer(SearchInput));
